import _ from '@lodash';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import DriverLogService from 'app/admin/driverLog/service/DriverLogService';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import ModelCalculate from 'app/admin/common/component/ModelCalculate';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormComponentMassSomethingField from 'app/admin/common/component/EditFormComponentMassSomethingField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import StorageDriverService from 'app/admin/driver/service/StorageDriverService';
import Lummus2ModelEditService from '../service/Lummus2ModelEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const handleUnitOpsCode = (dto, field) => {
	const items = [];
	if (_.isArray(dto[field])) {
		dto[field].forEach(item => {
			if (_.isString(item.name) && item.name.length > 0 && _.isString(item.code) && item.code.length > 0)
				items.push({
					label: `${item.code} - ${item.name}`,
					value: item.code
				});
		});
	}
	return new Promise(resolve => resolve(items));
};

const config = data => {
	const storageDriverService = new StorageDriverService();
	return {
		key: 'lummus2ModelEditForm',
		topic: 'model',
		service: Lummus2ModelEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'inputUnitOps' }, { key: 'outputUnitOps' }, { key: 'inputAttributes' }, { key: 'outputAttributes' }, { key: 'components' }];
		},
		backLink: () => '/model',
		defaultValue: () => Lummus2ModelEditService.create(data.driverName),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'driver',
					component: EditFormSelectField,
					required: true,
					items: () => storageDriverService.getListSelectionByDriverType('lummus2')
				},
				{
					key: 'version',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				// {
				// 	key: 'state_file',
				// 	component: EditFormFileInputField
				// },
				// {
				// 	key: 'driverLog',
				// 	component: EditFormSelectField,
				// 	items: () => DriverLogService.getListSelection()
				// },
				{
					key: 'simulationId',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'subscriptionKey',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'image',
					component: EditFormFileInputField,
					required: true
				},
				{
					key: 'inputUnitOps',
					tab: 'inputUnitOps',
					component: EditFormGridComponent,
					defaultValue: {
						id: null,
						code: null,
						name: null,
						typeCode: null
					},
					fields: [
						{
							key: 'code',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'typeCode',
							component: EditFormTextField,
							required: true
						}
					]
				},
				{
					key: 'outputUnitOps',
					tab: 'outputUnitOps',
					component: EditFormGridComponent,
					defaultValue: {
						id: null,
						code: null,
						name: null,
						typeCode: null
					},
					fields: [
						{
							key: 'code',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'typeCode',
							component: EditFormTextField,
							required: true
						}
					]
				},
				{
					key: 'inputAttributes',
					tab: 'inputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						code: null,
						title: null,
						name: null,
						unitOpCode: null,
						type: null,
						value: null,
						minValue: null,
						maxValue: null,
						orderIndex: null
					},
					fields: [
						{
							key: 'title',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'code',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'unitOpCode',
							component: EditFormSelectField,
							type: 'enum',
							required: true,
							filterKey: 'inputUnitOps',
							itemsParameterIsDto: true,
							items: dto => handleUnitOpsCode(dto || initData, 'inputUnitOps')
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'ComponentMassFrac', value: 'ComponentMassFrac' }
							]
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							type: 'MIN_MAX',
							minValueField: 'minValue',
							maxValueField: 'maxValue',
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFrac',
							enumByField: 'components'
						},
						{
							key: 'minValue',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						{
							key: 'maxValue',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true
						}
					]
				},
				{
					key: 'outputAttributes',
					tab: 'outputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						code: null,
						name: null,
						unitOpCode: null,
						type: null,
						value: null,
						title: null,
						orderIndex: null
					},
					fields: [
						{
							key: 'title',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'code',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'unitOpCode',
							component: EditFormSelectField,
							type: 'enum',
							required: true,
							filterKey: 'outputUnitOps',
							itemsParameterIsDto: true,
							items: dto => handleUnitOpsCode(dto, 'outputUnitOps')
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'ComponentMassFrac', value: 'ComponentMassFrac' }
							]
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFrac',
							enumByField: 'components'
						}
					]
				},
				{
					key: 'components',
					tab: 'components',
					component: EditFormGridComponent,
					defaultValue: {
						id: null,
						name: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'value',
							component: EditFormTextField,
							type: 'number',
							required: true
						}
					]
				}
			];

			return fields;
		}
	};
};

function Lummus2ModelEditForm(props) {
	const { id, driverName } = useParams();
	const dispatch = useDispatch();

	const myConfig = config({ id, driverName });
	return (
		<EditFormPage
			config={myConfig}
			beforeSaveContent={<ModelCalculate id={id} type="model" />}
		// onSave={result => {
		// 	if (!result.engineSuccessful) dispatch(showMessage({ message: `Engine: ${result.engineMessage}` }));
		// }}
		/>
	);
}

export default withRouter(Lummus2ModelEditForm);
